class KesaMegaMenu extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.closeTimer = null;

    if (!this.details || !this.summary) return;

    this.addEventListener('mouseenter', this.open.bind(this));
    this.addEventListener('mouseleave', this.queueClose.bind(this));
    this.addEventListener('focusin', this.open.bind(this));
    this.addEventListener('focusout', this.closeOnFocusOut.bind(this));
  }

  isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  open() {
    if (!this.isDesktop()) return;
    clearTimeout(this.closeTimer);
    this.details.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');
  }

  queueClose() {
    if (!this.isDesktop()) return;
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => this.close(), 120);
  }

  closeOnFocusOut() {
    if (!this.isDesktop()) return;
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  close() {
    this.details.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('kesa-mega-menu', KesaMegaMenu);
